import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledContactSettings = styled.div`
  margin: 13px 0 25px;
  direction: rtl;
  width: 100%;
  overflow-x: hidden; /* Prevent horizontal scroll */
  box-sizing: border-box;

  .row {
    display: grid;
    grid-template-columns: 85px 1fr auto;
    align-items: center;
    padding: 18px 0;
    border-bottom: 0.5px solid ${colors.lightBlueGray};
    cursor: pointer;
    gap: 20px;
    min-width: 0; /* Prevent grid overflow */

    &.read-only {
      cursor: default;
    }

    &.edit-mode {
      grid-template-columns: 85px 1fr;
    }

    @media (max-width: 768px) {
      gap: 12px;
      padding: 15px 0;
      grid-template-columns: 70px 1fr auto;

      &.edit-mode {
        grid-template-columns: 70px 1fr;
      }
    }

    .label {
      font-size: 14px;
      color: ${colors.blueGray};
      font-weight: 400;
      text-align: right;

      @media (max-width: 768px) {
        font-size: 13px;
      }
    }

    .display-value {
      font-size: 16px;
      color: ${colors.darkBlue};
      cursor: pointer;
      text-align: right;
      word-break: break-word;
      overflow-wrap: break-word;

      &.read-only {
        cursor: default;
        color: ${colors.blueGray};
      }

      @media (max-width: 768px) {
        font-size: 15px;
      }
    }

    .button-container {
      display: flex;
      gap: 0.5rem;
      justify-self: start;
      flex-shrink: 0; /* Prevent button shrinking */

      @media (max-width: 768px) {
        gap: 0.25rem;
      }
    }
  }

  .input-container {
    display: flex;
    align-items: center;
    gap: 8px;
    grid-column: 2;
    min-width: 0; /* Prevent flex overflow */
    width: 100%;

    @media (max-width: 768px) {
      gap: 6px;
    }
  }

  .input-field {
    border: 1px solid ${colors.lightBlueGray};
    border-radius: 8px;
    font-size: 1rem;
    background: ${colors.white};
    font-family: "Noto Sans Hebrew", sans-serif;
    padding: 8px 12px;
    flex: 1;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: ${colors.blue};
    }

    &::placeholder {
      color: ${colors.blueGray};
    }

    @media (max-width: 768px) {
      font-size: 16px; /* Prevent zoom on iOS */
    }
  }

  .edit-button {
    background: none;
    border: none;
    cursor: pointer;
    grid-column: 3;
    justify-self: start;
    border-radius: 4px;
    color: ${colors.darkBlue};

    img {
      width: 15px;
      height: 15px;
    }
  }

  .save-button,
  .cancel-button {
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: inherit;
    flex-shrink: 0; /* Prevent button shrinking */

    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }

    @media (max-width: 768px) {
      width: 28px;
      height: 28px;
    }
  }

  .save-button {
    color: ${colors.green};

    &:hover {
      background-color: ${colors.green}15;
      color: ${colors.green};
    }
  }

  .cancel-button {
    color: ${colors.red};

    &:hover {
      background-color: ${colors.red}15;
      color: ${colors.red};
    }
  }

  .tags-container {
    grid-column: 2;
    display: flex;
    align-items: center;
    min-height: 40px;
    min-width: 0; /* Prevent overflow */
  }

  .tags-edit-container {
    grid-column: 2;
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0; /* Prevent overflow */
  }

  .tags-display {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
  }

  .no-tags {
    color: ${colors.blueGray};
    font-style: italic;
  }
`;
